/* eslint-disable */
/* eslint-disable quotes */

// ref: https://github.com/missive/emoji-mart/blob/main/packages/emoji-mart-data/i18n/en.json

export default {
  search: 'Rechercher',
  search_no_results_1: 'Oh non!',
  search_no_results_2: 'Cet emoji n’a pas été trouvé',
  pick: 'Choisissez un emoji…',
  add_custom: 'Ajouter un emoji personnalisé',
  categories_activity: 'Activité',
  categories_custom: 'Custom',
  categories_flags: 'Drapeaux',
  categories_foods: 'Aliments et boissons',
  categories_frequent: 'Utilisées fréquemment',
  categories_nature: 'Animaux et nature',
  categories_objects: 'Objets',
  categories_people: 'Frimousses et personnes',
  categories_places: 'Voyages et lieux',
  categories_search: 'Résultats de la recherche',
  categories_symbols: 'Symboles',
  skins_choose: 'Choisissez une couleur de peau par défaut',
  skins_1: 'Par défaut',
  skins_2: 'Clair',
  skins_3: 'Moyen-clair',
  skins_4: 'Moyen',
  skins_5: 'Moyen-foncé',
  skins_6: 'Foncé',
};

// @key: @#@"search"@#@ @source: @#@"Search"@#@
// @key: @#@"search_no_results_1"@#@ @source: @#@"Oh no!"@#@
// @key: @#@"search_no_results_2"@#@ @source: @#@"That emoji couldn’t be found"@#@
// @key: @#@"pick"@#@ @source: @#@"Pick an emoji…"@#@
// @key: @#@"add_custom"@#@ @source: @#@"Add custom emoji"@#@
// @key: @#@"categories_activity"@#@ @source: @#@"Activity"@#@
// @key: @#@"categories_custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"categories_flags"@#@ @source: @#@"Flags"@#@
// @key: @#@"categories_foods"@#@ @source: @#@"Food & Drink"@#@
// @key: @#@"categories_frequent"@#@ @source: @#@"Frequently used"@#@
// @key: @#@"categories_nature"@#@ @source: @#@"Animals & Nature"@#@
// @key: @#@"categories_objects"@#@ @source: @#@"Objects"@#@
// @key: @#@"categories_people"@#@ @source: @#@"Smileys & People"@#@
// @key: @#@"categories_places"@#@ @source: @#@"Travel & Places"@#@
// @key: @#@"categories_search"@#@ @source: @#@"Search Results"@#@
// @key: @#@"categories_symbols"@#@ @source: @#@"Symbols"@#@
// @key: @#@"skins_choose"@#@ @source: @#@"Choose default skin tone"@#@
// @key: @#@"skins_1"@#@ @source: @#@"Default"@#@
// @key: @#@"skins_2"@#@ @source: @#@"Light"@#@
// @key: @#@"skins_3"@#@ @source: @#@"Medium-Light"@#@
// @key: @#@"skins_4"@#@ @source: @#@"Medium"@#@
// @key: @#@"skins_5"@#@ @source: @#@"Medium-Dark"@#@
// @key: @#@"skins_6"@#@ @source: @#@"Dark"@#@
